import React from 'react';
import { Link } from 'react-router-dom';
import styles from './about.module.scss';

const About = () => {
  return (
    <div className="container">
      <div className="row">
        <div class="col-lg-12">
          <div className={styles.aboutAllBlock}>
            <h1>Apie projektą</h1>
            <p>
              Ši interneto platforma skirta Verslo subjektams, norintiems teikti
              paraiškas pagal įvairias skatinamąsias finansines priemones.
            </p>
            <p> Detalų sąrašą galite peržiūrėti prisijungę prie sistemos. </p>
            <p>
              Priemonę parengė Ekonomikos ir inovacijų ministerija ir UAB
              „Investicijų ir verslo garantijos“ („Invega“). Projekto techninę
              pusę įgyvendina bendrovė „Fintegry".
            </p>
            <p>
              Daugiau informacijos apie finansavimo teikimo sąlygas rasite{' '}
              <Link to={'/description'}>Priemonių aprašymuose</Link>.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
